import {ValidationErrorKeys} from '@hconnect/common/consts'
import {TFunction} from 'i18next'
import {object, string} from 'yup'

/** Maximum length of the comment enforced by common comments service */
const COMMENT_MAX_LENGTH = 10000

export const getPerformanceReviewCommentValidationSchema = ({t}: {t: TFunction}) =>
  object().shape({
    comment: string()
      .trim()
      .max(COMMENT_MAX_LENGTH, t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH}))
      .required(t(ValidationErrorKeys.REQUIRED)),
    kpiType: string().required(t(ValidationErrorKeys.REQUIRED))
  })
